import {FormControl, InputLabel, MenuItem, Select, Stack, Typography} from '@mui/material';
import {FC, useCallback} from 'react';

import {useOptionalStringQueryString} from '@shared_web/lib/use_query_string';

import {FILTER_CONTROL_WIDTH, FILTER_LABEL_WIDTH} from '@website_frontend/components/filter_form';

const DPE_RATINGS = ['A', 'B', 'C', 'D', 'E', 'F', 'G'] as const;

type Props = {
  title: string;
  minLabel?: string;
  maxLabel?: string;
  minParamName: string;
  maxParamName: string;
};

export const FilterDpeMinMax: FC<Props> = ({
  title,
  minLabel = 'Min',
  maxLabel = 'Max',
  minParamName,
  maxParamName,
}) => {
  const [minValue, setMinValue] = useOptionalStringQueryString(minParamName);
  const [maxValue, setMaxValue] = useOptionalStringQueryString(maxParamName);

  const handleMinChange = useCallback(
    (e: {target: {value: string}}) => {
      const value = e.target.value;
      setMinValue(value === '' ? undefined : value);
    },
    [setMinValue]
  );

  const handleMaxChange = useCallback(
    (e: {target: {value: string}}) => {
      const value = e.target.value;
      setMaxValue(value === '' ? undefined : value);
    },
    [setMaxValue]
  );

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="subtitle1" sx={{width: FILTER_LABEL_WIDTH, flexShrink: 0}}>
        {title}
      </Typography>
      <Stack direction="row" spacing={1} sx={{width: FILTER_CONTROL_WIDTH}}>
        <FormControl size="small" sx={{width: '50%', minWidth: 0}}>
          <InputLabel>{minLabel}</InputLabel>
          <Select value={minValue ?? ''} onChange={handleMinChange} label={minLabel}>
            <MenuItem value="">Tous</MenuItem>
            {DPE_RATINGS.map(rating => (
              <MenuItem key={rating} value={rating}>
                {rating}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{width: '50%', minWidth: 0}}>
          <InputLabel>{maxLabel}</InputLabel>
          <Select value={maxValue ?? ''} onChange={handleMaxChange} label={maxLabel}>
            <MenuItem value="">Tous</MenuItem>
            {DPE_RATINGS.map(rating => (
              <MenuItem key={rating} value={rating}>
                {rating}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Stack>
  );
};

FilterDpeMinMax.displayName = 'FilterDpeMinMax';
